import { render } from "./ScholarlyArticles.vue?vue&type=template&id=477a97a1&scoped=true"
import script from "./ScholarlyArticles.vue?vue&type=script&lang=js"
export * from "./ScholarlyArticles.vue?vue&type=script&lang=js"

import "./ScholarlyArticles.vue?vue&type=style&index=0&id=477a97a1&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477a97a1"]])

export default __exports__